
<div class="d-flex flex-column">
  <div class="d-flex flex-row">
    <qpoint-button (buttonClicked)="toggleDisabled()">toggle disabled</qpoint-button>
  </div>
  <qpoint-color-picker [formControl]="fc"></qpoint-color-picker>
</div>
